import React from "react";
import { Box, Link, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { styles } from "../styles/publicStyles";

// A public tab with nothing to show yet (no subprocessors, frameworks,
// resources or updates): the app's empty-state card (as on Audits) with an
// icon, a title, one line naming the company, and the company's security
// contact when it has one.
const EmptySection = ({ icon: Icon, title, message, company, askText }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        ...styles.mainCard,
        overflow: "hidden",
        backgroundColor: theme.customColors.background.main,
      }}
    >
      <Stack
        alignItems="center"
        spacing={1.5}
        sx={{ px: 3, py: 6, textAlign: "center" }}
      >
        {Icon && (
          <Icon
            aria-hidden
            sx={{ fontSize: 40, color: theme.customColors.icons.secondary }}
          />
        )}
        <Typography variant="h6">{title}</Typography>
        <Typography
          variant="body2"
          sx={{ maxWidth: 440, color: theme.customColors.text.secondary }}
        >
          {message}
          {company?.securityEmail ? (
            <>
              {" "}
              {askText || "To ask about this"}, email{" "}
              <Link href={`mailto:${company.securityEmail}`}>
                {company.securityEmail}
              </Link>
              .
            </>
          ) : null}
        </Typography>
      </Stack>
    </Box>
  );
};

// "Acme", or a neutral subject when the name is missing.
export const companyName = (company) => company?.name || "This company";

export default EmptySection;
